<template>
  <div>
    <!-- 领英登录按钮 -->
    <button @click="handleClickLinkinLogin" class="linkedin-btn">
      <i class="iconfont">&#xe6fa;</i>
      <span>Sign in with LinkedIn</span>
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LinkedInLogin',
  data() {
    return {
      // 领英配置（根据实际应用信息修改）
      linkedinConfig: {
        clientId: '86fl35a2btjrap', // 替换为实际Client ID
        redirectUri: `/callback/linkedin`, // 与开发者平台一致
        responseType: 'code', // 授权码模式
        scope: 'openid profile email', // 权限范围
        state: this.$route.fullPath, // 防CSRF，随机字符串
      },
    }
  },
  computed: {
    ...mapState({
      vbef_path: (state) => state.vbef_path,
      isMobile: (state) => state.isMobile,
    }),
  },
  methods: {
    handleClickLinkinLogin() {
      if(!this.isMobile) this.openLinkedInPopup()
      else this.linkedinLogin()
    },
    // 跳转领英授权页
    linkedinLogin() {
      const { clientId, redirectUri, responseType, scope, state } = this.linkedinConfig
      const authUrl =
        `https://www.linkedin.com/oauth/v2/authorization?` +
        `client_id=${clientId}` +
        `&redirect_uri=${encodeURIComponent(this.vbef_path + redirectUri)}` +
        `&response_type=${responseType}` +
        `&scope=${encodeURIComponent(scope)}` +
        `&state=${state}`
      // 跳转授权页
      window.location.href = authUrl
    },

    // 解析回调页的授权码（在回调页面组件中调用）
    getLinkedInCode() {
      const urlParams = new URLSearchParams(window.location.search)
      const code = urlParams.get('code')
      const state = urlParams.get('state')
      const error = urlParams.get('error')

      if (error) {
        console.error('领英授权失败：', error)
        this.$message.error('登录失败，请重试')
        return
      }

      if (code && state === this.linkedinConfig.state) {
        // 校验state防CSRF，然后将code传给后端换取token和用户信息
        this.$emit('success', code)
      }
    },
    openLinkedInPopup() {
      const { clientId, redirectUri, responseType, scope, state } = this.linkedinConfig
      const width = 600
      const height = 700
      const left = window.screen.width / 2 - width / 2
      const top = window.screen.height / 2 - height / 2

      // 打开弹窗
      const popup = window.open(
        `https://www.linkedin.com/oauth/v2/authorization?` +
          `client_id=${clientId}` +
          `&redirect_uri=${encodeURIComponent(this.vbef_path + redirectUri)}` +
          `&response_type=${responseType}` +
          `&scope=${encodeURIComponent(scope)}` +
          `&state=${state}`,
        'LinkedIn授权',
        `width=${width},height=${height},left=${left},top=${top}`
      )

      // 轮询弹窗状态，监听回调
      const checkPopup = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkPopup)
          return
        }
        try {
          // 回调页需与主页面同域，否则无法访问popup.location
          const popupUrl = popup.location.href
          if (popupUrl.includes(redirectUri)) {
            const urlParams = new URLSearchParams(popupUrl.split('?')[1])
            const code = urlParams.get('code')
            if (code) {
              popup.close()
              clearInterval(checkPopup)
              this.$emit('success', code)
            }
          }
        } catch (e) {
          // 跨域时捕获错误，不影响流程
        }
      }, 500)
    },
  },
  mounted() {
    // 如果当前页面是回调页，挂载时解析code
    // if (window.location.pathname === '/callback') {
    //   this.getLinkedInCode()
    // }
  },
}
</script>

<style lang='stylus' scoped>
.linkedin-btn
  background-color #0077b5
  border none
  border-radius 6px
  transition all 0.3s
  cursor pointer
  font-size 14px
  font-weight 400
  width 100%
  color #FFFFFF
  line-height 1
  box-shadow none
  outline none
  height 34px
  i
    margin-right 6px
  &:hover
    background-color #005f87
</style>